import React, { useState, useEffect,useLayoutEffect } from 'react';
import { Button } from "../atoms/button";
import { Label } from "../atoms/label";
import { Line } from "../atoms/line";
import { Link } from "react-router-dom";
import { TimeSet } from "../molecules/timeSet";
import useMedia from 'use-media';

import image_base from '../../resources/image/GrandeeHamanako2.jpg';
import { useHistory } from 'react-router-dom';
import { useRtoaster } from '../../hooks/useRtoaster';
import { connect ,useStore} from "react-redux";
import { GolfStartTimeSelectFooterContainer } from './golfStartTimeSelectFooterContainer';
import common from "../../resources/js/common/common"
import { versionGetApi } from '../../const';
import { apiKeyCheck } from '../../const';
import "../../resources/css/reserve/reserve.css";
import commonUtil from '../../common/commonUtil';

const StartTimeSelectContainer = (props) => {
    const countData = [
        { option: "人数", value: 0 }, { option: "2名", value: 2 }, { option: "3名", value: 3 }, { option: "4名", value: 4 },
    ]
    const countDataSingle = [
        { option: "人数", value: 0 }, { option: "1名", value: 1 }, 
    ]
    const store = useStore();
    const { kaiinken, plan, addTeeTimeList,changeReserveNo, courseNames,reserveCheckInfo,addInputPlayer,facility} = props;

    const [course, setCourse] = useState([]);

    const linkFlg = [false, false, false, false, false, false];

    const history = useHistory();

    const [NotInput,setNotInput]= useState(false);
    const [oneReserve,setOneReserve]= useState(false);
    const [reservePlanTime,setReservePlanTime]= useState(countData);
    const [courseName, setCourseName] = useState("");
    const [planDate, setPlanDate] = useState("");

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);

    // rtoasterタグ生成
    let customParam = {};
    if (reserveCheckInfo.length !== 0) {
        let jsonTxt = reserveCheckInfo.reservationsDayInformationList[0].ntgGeneralPurposeItem;
        let jsonObj = JSON.parse(jsonTxt);
        const contractNo = jsonObj.ResortTrustInfomation.ownerMemberCode;
        const riyoDate = new Date(reserveCheckInfo.playDate);
        const course = store.getState().course;
        const facilityCd = course?.length ? course.find(value => value.id == reserveCheckInfo.golfCourseID)?.facilityCd : "";
        customParam = {
            "sisetucd": facilityCd,
            "riyodat": `${riyoDate.getFullYear()}-${(riyoDate.getMonth() + 1).toString().padStart(2, "0")}-${(riyoDate.getDate()).toString().padStart(2, "0")}`,
            "keiyakuno": contractNo,
            "packcd": plan.planid,
            "packnam": plan.planname,
        }
    } else {
        const courseList = store.getState().course;
        const riyoDate = new Date(plan.plansets[0].playdates[0].playdate);
        let contractNo = "";
        kaiinken.forEach((data) => {
            if (data.selected === true) {
                contractNo = data.contractNo;
            }
        });
        customParam = {
            "sisetucd": courseList.find(value => value.id == plan.golfCourseID)?.facilityCd,
            "riyodat": `${riyoDate.getFullYear()}-${(riyoDate.getMonth() + 1).toString().padStart(2, "0")}-${(riyoDate.getDate()).toString().padStart(2, "0")}`,
            "keiyakuno": contractNo,
            "packcd": plan.planid,
            "packnam": plan.planname,
        }
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
          let state = store.getState().login;
          let apiKey = null;
          if(Object.keys(state).length !== 0){   
              apiKey = state.apiKey;
          }
          if(apiKey === null){
              store.dispatch({ type: "CLEAR_STATE"});
              history.push("/reserve/login");
          }
          if(apiKey){
           common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
          }
      })
      const afterApiKeyCheck = (res) => {
          if(!res.data){
              console.log("バックからの戻り値false");
              store.dispatch({ type: "CLEAR_STATE"});
              history.push("/reserve/login");
          }
      }

    useEffect(() => {

        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);

        const planName = store.getState().plan.planname;
        if(planName === "１人予約"){
            setReservePlanTime(countDataSingle);
        }
        
        const plansets = plan.plansets;

        let courseList = [];

        // 前回入力した人数を反映
        let teeTimeList = store.getState().teeTimeList;

        //予約変更の場合は予約情報から人数の自動入力
        if(teeTimeList.length === 0 || teeTimeList === undefined || teeTimeList === null){
            let timeList = [];
            plansets.forEach((plan) => {
                plan.playdates.forEach((playdate) => {
                    playdate.courses.forEach((course) => {
                        course.teetimes.forEach((teetime) => {
                            if(teetime.count !== undefined){
                                let autoPlayer = {
                                    teeTime: teetime.teetime,
                                    courseID: course.courseID,
                                    courseName:course.courseName,
                                    playerCount: teetime.count,
                                }
                                timeList.push(autoPlayer);
                            }
                        })
                    })
                })
            })
            if(timeList.length !== 0){
                teeTimeList = timeList;
            }
        }

        if(plansets === undefined){
            return;
        }

        for (let i = 0; i < plansets.length; i++) {
            let plansetID = plansets[i].plansetID;
            let priceTotal = plansets[i].priceTotal;
            let playdates = plansets[i].playdates;

            for (let j = 0; j < playdates.length; j++) {
                let courses = playdates[j].courses;

                for (let k = 0; k < courses.length; k++) {
                    let courseID = courses[k].courseID;
                    let courseName = courses[k].courseName;

                    courses[k].teetimes.forEach((value) => {
                        let teetime = value.teetime;
                        if (teetime.charAt(1) === ":") {
                            teetime = `0${teetime}`;
                        }
                        const filtered = teeTimeList.filter((data) => {return (teetime === data.teeTime && courseName === data.courseName)});
                        const playerCount = filtered.length ? filtered[0].playerCount : 0;
                        const planObject = {
                            plansetID: plansetID,
                            priceTotal: priceTotal,
                            courseID: courseID,
                            courseName: courseName,
                            teetime: teetime,
                            discount: value.discount,
                            usageFeeType: "",
                            usageFee: value.usageFee,
                            playerCount: playerCount,
                        }
                        courseList = [...courseList, planObject];
                    });
                }
            }
        }

        // プレイヤー入力値の初期化
        const playerInitialize = [];
        store.dispatch({ type: "ADD_INPUT_PLAYER_INFO", payload: {inputPlayerInfo:playerInitialize}});

        // teetimeによるソート処理
        courseList.sort((data1, data2) => {
            let teetime1 = data1.teetime;
            let teetime2 = data2.teetime;
            teetime1 = Date.parse(`2000/01/01 ${teetime1}`);
            teetime2 = Date.parse(`2000/01/01 ${teetime2}`);
            return teetime1 - teetime2
        });
        setPlanInfo();
        setCourse(courseList);
        common.scrollWindowTop();
    }, []);

    //ゴルフ場名と日付を表示ステートに詰める
    const setPlanInfo = () => {
        //予約確認からの場合
        if(reserveCheckInfo !== undefined && reserveCheckInfo !== null && reserveCheckInfo.length !== 0){
            setCourseName("ゴルフ場：" + reserveCheckInfo.golfCourseName);
            setPlanDate("プレー日：" + commonUtil.getStringFromDateJpnGolf(reserveCheckInfo.playDate.substr(0, 10)));
        }else{  /* 正規予約の場合 */
            if(facility){
                setCourseName("ゴルフ場：" + facility.name);
            }
            if(plan && plan.plansets && plan.plansets[0].playdates){
                setPlanDate("プレー日：" + commonUtil.getStringFromDateJpnGolf(plan.plansets[0].playdates[0].playdate.substr(0, 10)));
            }
        }
    }

    const dateForm = (res) => {
        let date = res.substr(0, 4) + "年";
        if (res.substr(5, 1) === '0') {
            date = date + res.substr(6, 1) + "月";
        } else {
            date = date + res.substr(5, 2) + "月";
        }

        if (res.substr(8, 1) === '0') {
            date = date + res.substr(9, 1) + "日";
        } else {
            date = date + res.substr(8, 2) + "日";
        }
        return date;
    }

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if(flg){
            history.push("/reserve/login");
            return;
        }
    }

    const onClickBack = (res) => {
        if (res) {
            if(changeReserveNo !== undefined && changeReserveNo !== null && changeReserveNo !== ""){
                history.push("/reserve/golf/bookingConfirmDetaile");
            }else{
                history.push("/reserve/golf/searchResult");
            }
        } else {

        }
    };

    const onClickNext = () => {
        const tempList = course.map((data) => {
            return {
                teeTime: data.teetime,
                courseID: data.courseID,
                courseName:data.courseName,
                playerCount: data.playerCount,
                playerList: [],
                planSetId: data.plansetID,
                price: data.priceTotal,
                discount: data.discount,
                referralPrice: "",
                priceVisitorAccompany: "",
                additionalFee2b: "",
                additionalFee3b: "",
                usageFeeType: data.usageFeeType,
                usageFee: data.usageFee,
                usageFeeRate: "",
                maxUsageFee: "",
            }
        });

        const teeTimeList = tempList.filter((data) => {
            return data.playerCount !== 0;
        });

        //バリデーションチェック
        let flg = false;
        // 入力なしの場合は次画面遷移しない
        if (teeTimeList.length === 0){
            setNotInput(true);
            common.scrollWindow("section00");
            flg = true;
        }
        else{
            setNotInput(false);
        }
        
        if(reserveCheckInfo !== undefined && reserveCheckInfo !== null && reserveCheckInfo.length !== 0){
            let playerSumList = [];
            //予約情報を選択された時間とコースIDで絞る
            teeTimeList.map((data) => {
                let reserveTeeTime = reserveCheckInfo.teeTimeList.filter((reserve, idx)=>{
                    let hour = reserve.teeTime.substr(0,2);
                    let minite = reserve.teeTime.substr(2,4);
                    let time = hour+':'+minite;
                    return data.teeTime === time && data.courseID.toString() === reserve.courseID;
                })
                //予約情報を自動入力
                let playerList = [];
                for(let i = 0; i < data.playerCount; i++){
                    // let flg = true;
                    //自動入力できる箇所がある場合
                    if(i === 0){
                        reserveTeeTime.map((reserveData) => {
                            reserveData.playerList.map((player) => {
                                let undecided = false;
                                if(player.playerName === "未記入"){
                                    undecided = true;
                                }
                                let name = player.playerName.split(" ");
                                let nameKana = player.playerNameKana.split(" ");
                                let representFlg = false;
                                if(player.webUserFlag === 1){
                                    representFlg = true;
                                }
                                const inputPlayerInfo = {
                                    courseId:reserveData.golfCourseID,
                                    familyName: undecided ? "" : name[0],
                                    name: undecided ? "" : name[1],
                                    familyNameKana: undecided ? "" : nameKana[0],
                                    nameKana: undecided ? "" : nameKana[1],
                                    undecided: undecided,
                                    represent: representFlg,
                                    gender: player.genderType.toString(),
                                }
                                // flg = false;
                                playerList.push(inputPlayerInfo);
                            })
                        })
                    }
                    //自動入力できる箇所がない場合は初期値
                    if(playerList.length < data.playerCount){
                        const brunkObj = {
                            courseId:"",
                            familyName: "",
                            name: "",
                            familyNameKana: "",
                            nameKana: "",
                            undecided: "",
                            represent: "",
                            gender: "0",
                        }
                        playerList.push(brunkObj);
                    }
                }
                playerSumList.push(playerList);
            })
            addInputPlayer(playerSumList);
        }

        //おひとり様プランの場合は１人だけしか選択させない
        const planName = store.getState().plan.planname;
        if(planName === "１人予約"){
            if(teeTimeList.length > 1){
                setOneReserve(true);
                common.scrollWindow("section00");
                flg = true
            }
            else{
                setOneReserve(false);
            }
        }

        if(flg){
            return;
        }

        // 枠情報
        addTeeTimeList(teeTimeList);
        history.push("/reserve/golf/userInput");
    };

    const onChangeSelect = (e) => {
        course.forEach((data) => {
            let id = `${data.plansetID}${data.courseID}${data.teetime}${data.courseName}`;
            if (id === e.target.id) {
                data.playerCount = parseInt(e.target.value);
            }
        })
        setCourse(course)
    };

    return (
        <div style={styles.top} id="section00">
            {props.reserveType === "reserve" ? 
            <div style={Phone ? styles.breadCrumb2 : styles.breadCrumb}>
                <Link to={"/reserve/top"} style={styles.pan} >HOME</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/search"} style={styles.pan} >ゴルフ予約</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/searchResult"} style={styles.pan}>検索結果</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Label label="スタート時間" style={styles.pan} />
            </div>
            :
            <div style={Phone ? styles.breadCrumb2 : styles.breadCrumb}>
                <Link to={"/reserve/top"} style={styles.pan} >HOME</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/search"} style={styles.pan} >ゴルフ予約</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/bookingConfirmDetaile"} style={styles.pan} >予約詳細確認</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Label label="スタート時間" style={styles.pan} />
            </div>
            }
            <div style={Phone ? styles.base2 : styles.base}>
                <div style={Phone ? styles.box2 : styles.box}>
                    <Label label={planDate} style={styles.title2} />
                    <Label label={courseName} style={styles.title2} />
                    <Label label="スタート時間選択" style={styles.title} />
                    {(() => {
                        for (let i = 0; i < course.length; i++) {
                            const startTime = course[i].teetime.substr(0, 2);
                            if ("06" >= startTime) {
                                linkFlg[0] = true;
                            } else if ("07" == startTime) {
                                linkFlg[1] = true;
                            } else if ("08" == startTime) {
                                linkFlg[2] = true;
                            } else if ("09" == startTime) {
                                linkFlg[3] = true;
                            } else if ("10" == startTime) {
                                linkFlg[4] = true;
                            } else if ("11" <= startTime) {
                                linkFlg[5] = true;
                            }
                        }
                    })()}
                    <div style={styles.linkList} >
                        {linkFlg[0] ?
                            <div style={styles.link} onClick={(e) => common.scrollWindow('section06')} >6時台</div>
                            :
                            <Label label="6時台" style={styles.noLink} />
                        }
                        {linkFlg[1] ?
                            <div style={styles.link} onClick={(e) => common.scrollWindow('section07')} >7時台</div>
                            :
                            <Label label="7時台" style={styles.noLink} />
                        }
                        {linkFlg[2] ?
                            <div style={styles.link} onClick={(e) => common.scrollWindow('section08')} >8時台</div>
                            :
                            <Label label="8時台" style={styles.noLink} />
                        }
                        {Phone ? <div></div> : null}
                        {linkFlg[3] ?
                            <div style={styles.link} onClick={(e) => common.scrollWindow('section09')} >9時台</div>
                            :
                            <Label label="9時台" style={styles.noLink} />
                        }
                        {linkFlg[4] ?
                            <div style={styles.link} onClick={(e) => common.scrollWindow('section10')} >10時台</div>
                            :
                            <Label label="10時台" style={styles.noLink} />
                        }
                        {linkFlg[5] ?
                            <div style={styles.link2} onClick={(e) => common.scrollWindow('section11')} >11時台</div>
                            :
                            <Label label="11時台以降" style={styles.noLink2} />
                        }
                    </div>
                    <br/>
                    <div style={NotInput ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"}: {display: "none"}} > 人数を入力してください</div>
                    <div style={oneReserve ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"}: {display: "none"}} > おひとり様プランは１人しか選択できません</div>
                    <div>
                        {(() => {
                            let teetimes = [];
                            let duplicateMap = {};
                            // 時間帯重複考慮
                            for (let i = 0; i < course.length; i++) {
                                const teetime = course[i].teetime;
                                duplicateMap[teetime] = duplicateMap[teetime] ?
                                    {"texts":duplicateMap[teetime]["texts"].concat([course[i].courseName]),"players":duplicateMap[teetime]["players"].concat(course[i].playerCount),"doneFlg":false,"ids":duplicateMap[teetime]["ids"].concat(`${course[i].plansetID}${course[i].courseID}${course[i].teetime}${course[i].courseName}`)} :
                                    {"texts":[course[i].courseName],"players":[course[i].playerCount],"ids":[`${course[i].plansetID}${course[i].courseID}${course[i].teetime}${course[i].courseName}`],"doneFlg":false};
                            }
                            let time = "";
                            for (let i = 0; i < course.length; i++) {
                                let teetime = course[i].teetime;
                                let count = [];
                                if(time !== teetime){
                                    time = teetime;
                                }else{
                                    continue;
                                }
                                for(let j = 0; j < courseNames.length; j++){
                                    let flg = false;
                                    for(let k = 0; k < duplicateMap[teetime]["texts"].length; k++){
                                        if(flg){continue;}
                                        if(courseNames[j] === duplicateMap[teetime]["texts"][k]){
                                            flg = true;
                                            count.push(duplicateMap[teetime]["players"][k]);
                                        }
                                    }
                                    if(!flg){
                                        count.push(0);
                                    }
                                }
                                duplicateMap[teetime]["players"] = count;
                            }

                            const items = [];
                            let oldTime = "00";
                            let newTime = "00";
                            for (let i = 0; i < course.length; i++) {
                                const teetime = course[i].teetime;
                                newTime = teetime.substr(0, 2);
                                if (oldTime != newTime) {
                                    if (newTime >= "11" && oldTime < "11") {
                                        items.push(<div key="section11" id="section11" style={styles.section}>{"11時台以降"}</div>);
                                        oldTime = newTime;
                                    } else if (newTime > "06" && newTime <= "09") {
                                        items.push(<div key={"section" + newTime} id={"section" + newTime} style={styles.section}>{newTime.substr(1, 1) + "時台"}</div>);
                                        oldTime = newTime;
                                    } else if (newTime >= "10" && newTime < "11") {
                                        items.push(<div key={"section" + newTime} id={"section" + newTime} style={styles.section}>{newTime + "時台"}</div>);
                                        oldTime = newTime;
                                    }
                                }

                                const duplicate = duplicateMap[teetime];
                                let texts = [];
                                let ids = [];
                                let playerCounts = [];

                                if (duplicate){
                                    if (duplicate["doneFlg"]){
                                        continue;
                                    }
                                    texts = duplicateMap[teetime]["texts"];
                                    ids = duplicateMap[teetime]["ids"];
                                    playerCounts = duplicateMap[teetime]["players"];
                                    duplicate.doneFlg = true;
                                }
                                else {
                                    texts = [course[i].courseName];
                                    ids.push(`${course[i].plansetID}${course[i].courseID}${course[i].teetime}${course[i].courseName}`);
                                    playerCounts = [course[i].playerCounts];
                                }
                                items.push(
                                    <TimeSet
                                        reservePlanTime={reservePlanTime}
                                        key={ids}
                                        id={ids}
                                        timeValue={course[i].teetime}
                                        onChange={onChangeSelect}
                                        defaultValue={playerCounts}
                                        texts={texts}
                                        labels={courseNames}
                                    />
                                )
                            }
                            return <div> {items} </div>;
                        })()}
                    </div>
                    <div style={styles.btn}>
                        <Button buttonText="戻 る" className={isWideTablet ? "backBtnSp" : "backBtnPc"} onClick={onClickBack} />
                        <Button buttonText="利用者入力画面へ" className={isWideTablet ? "useBtnSp" : "useBtnPc"} onClick={onClickNext} />
                    </div>
                    <div style={styles.goTop}>
                        <Link style={styles.linkGoTop} to="/reserve/golf/search" >ゴルフ検索TOPへ戻る</Link>
                    </div>
                </div>
            </div>
            <GolfStartTimeSelectFooterContainer />
        </div>
    )
}

const styles = {
    top: {
        width: "100%",
        // paddingLeft: "100px",
        // paddingRight: "100px",
        paddingTop: "50px",
        paddingBottom: "10px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        marginLeft: "20%",
        marginBottom: "50px",
    },
    breadCrumb2: {
        display: "none",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    pan: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    base: {
        background: "rgba(245,245,245,0.94)",
        marginRight: "auto",
        marginLeft: "auto",
        textAlign: "center",
        width: "70%",
    },
    base2: {
        background: "rgba(245,245,245,0.94)",
        marginRight: "auto",
        marginLeft: "auto",
        width: "90%",
        textAlign: "center",
    },
    box: {
        display: "inline-block",
        textAlign: "left",
        margin: "10px",
    },
    box2: {
        display: "inline-block",
        textAlign: "left",
        margin: "15px",
        width: "calc(100% - 30px)",
    },
    title: {
        margin: "40px 0px 10px",
        fontSize: "small",
        color: "#808080",
        fontWeight: "700",
    },
    title2: {
        fontSize: "small",
        color: "rgb(111, 111, 111)",
        fontWeight: "700",
    },
    linkList: {
        //display: "table",
    },
    section: {
        margin: "30px 0px 10px",
        fontSize: "small",
        color: "#808080",
        fontWeight: "700",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        width: "55px",
        color: "#444444",
        textDecoration: "underline",
        cursor: "pointer",
        fontSize: "small",
    },
    link2: {
        display: "inline-block",
        padding: "3px",
        width: "85px",
        color: "#444444",
        textDecoration: "underline",
        cursor: "pointer",
        fontSize: "small",
    },
    noLink: {
        display: "inline-block",
        padding: "3px",
        width: "55px",
        color: "#CCCCCC",
        textDecoration: "underline",
        fontSize: "small",
        cursor: "pointer",
    },
    noLink2: {
        display: "inline-block",
        padding: "3px",
        width: "85px",
        color: "#CCCCCC",
        textDecoration: "underline",
        fontSize: "small",
        cursor: "pointer",
    },
    line: {
        //display: "table-cell",
        display: "inline-block",
        padding: "3px",
    },
    btn: {
        margin: "50px auto",
        textAlign: "center",
    },
    goTop: {
        textAlign: "center",
        fontSize: "small",
        marginBottom: "40px",
    },
    linkGoTop: {
        fontSize: "small",
        color: "#666666",
    },
}

const mapStateToProps = (state) => {
    return {
        kaiinken: state.kaiinken,
        plan: state.plan,
        courseNames: state.courseNames,
        reserveCheckInfo: state.reserveCheckInfo,
        changeReserveNo: state.changeReserveNo,
        facility:state.facility,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        addTeeTimeList: (item) => {
            dispatch({ type: "ADD_TEETIME_LIST", payload: { teeTimeList: item } })
        },
        addInputPlayer: (item) => {
            dispatch({ type: "ADD_INPUT_PLAYER_INFO", payload: { inputPlayerInfo: item} })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(StartTimeSelectContainer);
